import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import qs from "qs";

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({

  state: {
    // 存储token
    parkToken: localStorage.getItem('parkToken') ? localStorage.getItem('parkToken') : '',
    // 存储token的时间，判断时效
    parkTokenTime: localStorage.getItem('parkTokenTime') ? localStorage.getItem('parkTokenTime') : '',
    // 存用户名
    parkusername: localStorage.getItem('parkusername') ? localStorage.getItem('parkusername') : '',
     // 存角色
     parktype: localStorage.getItem('parktype') ? localStorage.getItem('parktype') : '',
    // 存菜单权限
    parkmenuid: localStorage.getItem('parkmenuid') ? localStorage.getItem('parkmenuid') : '',
    tokenStatus: true,
    //存储页面公用参数
    loading: false
  },

  mutations: {
    // 修改token，并将token存入localStorage
    parkLogin(state, token) {
      state.parkToken = token.parkToken;
      localStorage.setItem('parkToken', token.parkToken);
    },
    // 存token时，同时存入时间
    parkTokentime(state, time) {
      state.parkTokenTime = time.parkTokenTime;
      localStorage.setItem('parkTokenTime', time.parkTokenTime);
    },
    //存用户名
    parkName(state, user) {
      state.parkusername = user.parkusername;
      localStorage.setItem('parkusername', user.parkusername);
    },
    //存角色
    parkType(state, type) {
        state.parktype = type.parktype;
        localStorage.setItem('parktype', type.parktype);
      },
    //存菜单权限
    parkMenuid(state, menuid) {
      state.parkmenuid = menuid.parkmenuid;
      localStorage.setItem('parkmenuid', menuid.parkmenuid);
    },
    //删除用户
    del_User() {
      localStorage.removeItem("parkToken");
      localStorage.removeItem("parkusername");
      localStorage.removeItem("parktype");
      localStorage.removeItem("parkmenuid");
      localStorage.removeItem("parkTokenTime");
    },
    updateTokenStatus(state, bool) {
      state.tokenStatus = bool
    }
  }

});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js